import React from 'react';

export const PropertyTypesSection: React.FC = () => {
  const properties = [
    {
      title: 'Garden Apartments',
      image: 'https://public.readdy.ai/ai/img_res/f0ed04bf8f98426e73af9456c1e5ca18.jpg',
      link: '/we-buy-apartment-buildings/garden-apartments'
    },
    {
      title: 'Mid-Rise Buildings',
      image: 'https://readdy.ai/api/search-image?query=mid%20rise%20apartment%20building%20exterior%2C%20modern%20multifamily%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20urban%20apartment%20complex%20with%20balconies&width=380&height=280&seq=midrise-001&orientation=landscape',
      link: '/we-buy-apartment-buildings/mid-rise-apartments'
    },
    {
      title: 'Mixed-Use Properties',
      image: 'https://readdy.ai/api/search-image?query=mixed%20use%20building%20with%20retail%20and%20apartments%2C%20commercial%20residential%20property%2C%20professional%20real%20estate%20photography%2C%20urban%20development%20with%20street%20level%20shops&width=380&height=280&seq=mixed-001&orientation=landscape',
      link: '/we-buy-apartment-buildings/mixed-use-properties'
    },
    {
      title: 'Small Apartment Buildings',
      image: 'https://readdy.ai/api/search-image?query=small%20apartment%20building%20duplex%20triplex%20quadplex%2C%20residential%20multifamily%20property%2C%20professional%20real%20estate%20photography%2C%20neighborhood%20rental%20units%20with%20simple%20clean%20background&width=380&height=280&seq=small-apt-001&orientation=landscape',
      link: '/we-buy-apartment-buildings/small-apartment-buildings'
    },
    {
      title: 'Apartment Complexes',
      image: 'https://readdy.ai/api/search-image?query=large%20apartment%20complex%20with%20multiple%20buildings%2C%20multifamily%20residential%20community%2C%20professional%20real%20estate%20photography%2C%20property%20with%20amenities%20and%20parking&width=380&height=280&seq=complex-001&orientation=landscape',
      link: '/we-buy-apartment-buildings'
    },
    {
      title: 'Senior Communities',
      image: 'https://readdy.ai/api/search-image?query=senior%20living%20community%20buildings%20with%20accessible%20design%2C%20assisted%20living%20multifamily%20property%2C%20professional%20healthcare%20real%20estate%20photography%2C%20modern%20residential%20complex%20with%20landscaping&width=380&height=280&seq=senior-001&orientation=landscape',
      link: '/we-buy-apartment-buildings'
    }
  ];

  return (
    <section id="property-types" className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-8">
            We Buy All Types of <br />
            Multifamily Properties
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl">
            From small apartment complexes to large commercial buildings, we purchase multifamily properties 
            of all sizes and conditions across the United States.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {properties.map((property, index) => (
            <div 
              key={index} 
              className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-64">
                <img 
                  src={property.image}
                  alt={property.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {property.title}
                </h3>
                <a 
                  href={property.link}
                  className="inline-flex items-center text-orange-500 font-semibold hover:text-orange-600 transition-colors"
                >
                  Learn More 
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
